import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=1c6902ba&"
import script from "./DownloadLink.vue?vue&type=script&lang=ts&"
export * from "./DownloadLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports